"use client";

import { useEffect } from "react";

export function ServiceWorkerRegister() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      if (process.env.NODE_ENV === "production") {
        navigator.serviceWorker.register("/sw.js").then((registration) => {
          registration.update();
        }).catch(() => {
          // SW registration failed silently
        });
      } else {
        // Unregister any existing service worker in development
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((reg) => reg.unregister());
        });
      }
    }
  }, []);

  return null;
}
